import Gallery from './Gallery';

document.addEventListener('DOMContentLoaded', () => {
  const $gallery = document.querySelector('.c-gallery');
  if (!$gallery) {
    return;
  }

  const gallery = new Gallery($gallery);
  gallery.mount();
});
